/* eslint-disable */
import VueStoreService from '@/services/VueStoreService';

const BASE = 'recon-files';

const ReconFilesService = {
  listBatches(store) {
    return VueStoreService.get(BASE, store);
  },

  upload(files, type, store) {
    const form = new FormData();
    (files || []).forEach(f => form.append('files', f));
    form.append('type', type);
    return VueStoreService.postFile(BASE, form, store);
  },

  softDeleteBatch(batchId, store) {
    return VueStoreService.delete(`${BASE}/${batchId}`, store);
  },

  progress(batchId, store) {
    return VueStoreService.get(`${BASE}/${batchId}/progress`, store);
  },
};

export default ReconFilesService;
